import routes from 'app.routes';
import FilesIcon from 'components/v2/icons/FilesIcon';
import HomeIcon from 'components/v2/icons/HomeIcon';
import ListCheckIcon from 'components/v2/icons/ListCheckIcon';
import QuestionIcon from 'components/v2/icons/QuestionIcon';
import { useLocalization } from 'localization';
// import MegaPhoneIcon from 'components/v2/icons/MegaPhoneIcon';

export type SidebarItem = {
  label: string;
  route: string;
  icon: React.ReactNode;
};
export const useSidebarItems = () => {
  const { t } = useLocalization();

  const mainSidebarItems: SidebarItem[] = [
    {
      label: t('navigation.mainMenu.dashboard'),
      route: routes.v2.dashboard,
      icon: <HomeIcon />,
    },
    {
      label: t('navigation.mainMenu.tasks'),
      route: routes.v2.tasks.overview,
      icon: <ListCheckIcon />,
    },
    {
      label: t('common.terms.cases'),
      route: routes.v2.cases.overview,
      icon: <FilesIcon />,
    },
    // {
    //   label: t('navigation.mainMenu.campaigns'),
    //   route: routes.v2.campaigns.overview,
    //   icon: <MegaPhoneIcon />,
    // },
  ];

  const bottomSidebarItems: SidebarItem[] = [
    {
      label: t('navigation.mainMenu.helpCenter'),
      route: routes.v2.accountSettings.helpCenter,
      icon: <QuestionIcon />,
    },
    // {
    //   label: t('navigation.mainMenu.logout'),
    //   route: '/logout',
    //   icon: <SignOutIcon />,
    // },
  ];

  const mobileNavItems: SidebarItem[] = [
    {
      label: t('navigation.mainMenu.dashboard'),
      route: routes.v2.dashboard,
      icon: <HomeIcon />,
    },
    {
      label: t('navigation.mainMenu.tasks'),
      route: routes.v2.tasks.overview,
      icon: <ListCheckIcon />,
    },
    {
      label: t('common.terms.cases'),
      route: routes.v2.cases.overview,
      icon: <FilesIcon />,
    },
    // {
    //   label: t('navigation.mainMenu.campaigns'),
    //   route: routes.v2.campaigns.overview,
    //   icon: <MegaPhoneIcon />,
    // },
  ];

  return { mainSidebarItems, bottomSidebarItems, mobileNavItems };
};
